import React from "react"
import { Box } from "~common/components/Primitives"
import Typography from "~common/components/Typography"
import { shouldShowEnvironmentBanner } from "~common/utils/environment"

const EnvironmentBanner = ({ sx, ...rest }) => {
  if (!shouldShowEnvironmentBanner()) return null

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: "relative",
        width: "100%",
        zIndex: 9999,
        bg: "#db504a",
        color: "#fefefe",
        px: [3, 4],
        py: [2, 3],
        textAlign: "center",
        boxShadow: "0 -2px 12px rgba(0, 0, 0, 0.16)",
        ...sx,
      }}
      {...rest}
    >
      <Typography
        as="span"
        variant="small"
        sx={{ color: "inherit", fontWeight: 700 }}
      >
        TEST ENVIRONMENT - ORDERS ARE NOT REAL
      </Typography>
    </Box>
  )
}

export default EnvironmentBanner
